<template>
  <div class="text-center py-2 bg-white rounded">
    <div class="font-bold">Delete the user {{ deleteInfo.fullname }}</div>
    <div class="my-4">Click yes to confirm deletion</div>
    <div>
      <v-btn @click="$emit('cancelDelete')">Cancel</v-btn>
      <v-btn color="primary" @click="deleteNow">Yes</v-btn>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import EventBus from '@/EventBus'
export default {
  props: ["deleteInfo"],
  methods: {
    deleteNow() {
      let data = {
        user_id: this.deleteInfo.user_id,
      };
      Axios.post("/users/delete", data).then((res) => {
        if (res.data.status) {
          EventBus.$emit("refreshUsers",'deleted');
        }
      });
    },
  },
};
</script>
